__turbopack_context__.v({
  "label": "features-module__qJ9p_W__label",
  "sourceToggle": "features-module__qJ9p_W__sourceToggle",
});
